// 音符の周波数定義
export const NOTES = {
  G3: 196.0,
  A3: 220.0,
  B3: 246.94,
  C4: 261.63,
  D4: 293.66,
  E4: 329.63,
  F4: 349.23,
  G4: 392.0,
  A4: 440.0,
  B4: 493.88,
  C5: 523.25,
  D5: 587.33,
  E5: 659.25,
  F5: 698.46,
  G5: 783.99,
};

// コード定義
export const CHORDS = {
  Cmaj7: [NOTES["C4"], NOTES["E4"], NOTES["G4"], NOTES["B4"]],
  Am7: [NOTES["A3"], NOTES["C4"], NOTES["E4"], NOTES["G4"]],
  Dm7: [NOTES["D4"], NOTES["F4"], NOTES["A4"], NOTES["C5"]],
  G7: [NOTES["G3"], NOTES["B3"], NOTES["D4"], NOTES["F4"]],
};

// コード進行
export const CHORD_PROGRESSION = ["Cmaj7", "Am7", "Dm7", "G7"];

// 演奏パターン
export const PATTERN = [
  [0, 1.0],
  [-1, 0],
  [1, 0.7],
  [-1, 0],
  [2, 0.8],
  [1, 0.6],
  [3, 0.7],
  [-1, 0],
  [0, 0.9],
  [-1, 0],
  [2, 0.7],
  [3, 0.6],
  [1, 0.8],
  [-1, 0],
  [2, 0.6],
  [3, 0.5],
];
